import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { InputCustomEvent, IonInput, IonInputPasswordToggle, IonText } from '@ionic/angular/standalone';

import { SvgIconService } from '../../../services/svg-icon/svg-icon.service';
import { REGEX_CURRENCY_DOLLAR_REPLACE, REGEX_NUMBERS_ONLY_REPLACE } from '../../../shared';
import { InputWrapperComponent } from '../input-wrapper/input-wrapper.component';

@Component({
    selector: 'lib-input',
    standalone: true,
    imports: [IonText, CommonModule, IonInput, IonInputPasswordToggle, InputWrapperComponent, ReactiveFormsModule],
    templateUrl: './input.component.html',
    styleUrl: './input.component.css'
})
export class InputComponent {
    /* eslint-disable */
    @Input() label: string | undefined = '';
    @Input() placeholder?: string = '';
    @Input() type?:
        | 'date'
        | 'datetime-local'
        | 'email'
        | 'month'
        | 'number'
        | 'password'
        | 'search'
        | 'tel'
        | 'text'
        | 'time'
        | 'url'
        | 'week' = 'text';
    @Input() form: FormGroup = new FormGroup({
        input: new FormControl('')
    });
    @Input() controlName: string = 'input';
    @Input() required: boolean = false;
    @Input() submitAttempt: boolean = false;
    @Input() autocomplete: string = '';
    @Input() disabled: boolean = false;
    @Input() name: string = '';
    @Input() min: string | number | null = null;
    @Input() max: string | number | null = null;
    @Input() ionItemWrap = true;
    @Input() helperText: string | undefined = undefined;
    @Input() errorText: string | undefined = undefined;
    @Input() inputmode: string | undefined = undefined;
    @Input() pattern: any;
    @Input() maxlength: string | number | null = null;
    @Input() initialValue: any;
    @Input() debounce: number | undefined = undefined;
    @Input() errorBorder: boolean = false;
    @Input() readonly: boolean = false;
    @Input() displayValidationErrorsOnInput: boolean = false;

    @Input() limitInputToCurrency: boolean = false;
    @Input() limitInputToNumbers: boolean = false;

    @Output() onInputEvent = new EventEmitter();
    @Output() onBlurEvent = new EventEmitter();
    @Output() onFocusEvent = new EventEmitter();

    @ViewChild('input') input!: IonInput;

    formInput: AbstractControl | null = null;

    passwordHideIcon: string | null = '';
    passwordShowIcon: string | null = '';

    constructor(private svgIconService: SvgIconService) {
        this.passwordHideIcon =
            '../../../../assets/svg-icons/' + this.svgIconService.getIconFileNameFromObject('eye-outline');
        this.passwordShowIcon =
            '../../../../assets/svg-icons/' + this.svgIconService.getIconFileNameFromObject('eye-closed-outline');
    }

    ngOnInit() {
        if (this.initialValue && this.controlName) {
            this.form.get(this.controlName)?.patchValue(this.initialValue);
        }

        if (this.disabled) {
            this.form.disable();
        }
    }

    onInput(event: InputCustomEvent) {
        const value = event.detail.value;
        // console.log(value);
        const filteredValue = this.limitInputToCurrency
            ? value?.replace(REGEX_CURRENCY_DOLLAR_REPLACE, '')
            : this.limitInputToNumbers
              ? value?.replace(REGEX_NUMBERS_ONLY_REPLACE, '')
              : value;

        let useValueFlag = true;

        if (this.limitInputToNumbers && filteredValue && !this.isNumberWithinMinMax(filteredValue)) {
            useValueFlag = false;
        }

        if (this.limitInputToCurrency || (this.limitInputToNumbers && useValueFlag)) {
            this.input.value = filteredValue || '';
            this.setValue(filteredValue || '');
        }

        // console.log(useValueFlag);

        // console.log(this.form);

        const detailObj = { ...event.detail, value: useValueFlag ? filteredValue : '' };

        this.onInputEvent.emit({ ...event, detail: detailObj });
    }

    isNumberWithinMinMax(value: string | number | null | undefined) {
        if (!value) return false;
        const numberValue = Number.parseFloat(value.toString());
        if (this.min && Number.parseFloat(this.min.toString()) > numberValue) return false;
        if (this.max && Number.parseFloat(this.max.toString()) < numberValue) return false;
        return true;
    }

    onBlur(event: any) {
        this.onBlurEvent.emit(event);
    }

    onFocus(event: any) {
        this.onFocusEvent.emit(event);
    }

    setValue(value: string) {
        if (this.controlName) {
            this.form.get(this.controlName)?.patchValue(value);
        }
    }

    markAsTouched() {
        this.form.markAllAsTouched();
    }
}
